<template>
  <a
    :href="href"
    class="tw-flex tw-items-center tw-gap-[4px] tw-w-[fit-content]"
    target="_blank"
  >
    <PinIcon class="tw-h-[15px] tw-w-[14px]" />
    <span class="tw-flex tw-gap-[6px]">
      <span
        class="tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%] title"
        >{{ title }}</span
      >
      <span
        class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%] size"
        >{{ size }}</span
      >
      <div v-if="isShowClock" class="tw-h-[14px] tw-w-[14px]">
        <svg
          id="Lock-6--Streamline-Ultimate.svg"
          class="tw-mb-[14px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <desc>Lock 6 Streamline Icon: https://streamlinehq.com</desc>
          <defs></defs>
          <title>lock-6</title>
          <path
            d="M5.25 9.75h13.5s1.5 0 1.5 1.5v10.5s0 1.5 -1.5 1.5H5.25s-1.5 0 -1.5 -1.5v-10.5s0 -1.5 1.5 -1.5"
            fill="none"
            stroke="#878787"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          ></path>
          <path
            d="M6.75 9.75V6a5.25 5.25 0 0 1 10.5 0v3.75"
            fill="none"
            stroke="#878787"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          ></path>
          <path
            d="M9.75 16.5a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0 -4.5 0"
            fill="none"
            stroke="#878787"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          ></path>
        </svg>
      </div>
    </span>
  </a>
</template>

<script setup lang="ts">
import { PropType, ref } from "vue";
import PinIcon from "../svgs/pinIcon.vue";

defineProps({
  title: {
    type: String as PropType<string>,
    default: "attachmentname.pdf",
  },
  size: {
    type: String as PropType<string>,
    default: "-1KB",
  },
  href: {
    type: String as PropType<string>,
    default: "#",
  },
  isShowClock: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
});
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
